import { ComponentProps, JSXElementConstructor } from 'react';
import {
  Modal,
  hideHeader,
  registerModals,
  NavigationConfig,
  registerNavigationHandlers,
} from '@betty/navigation';
import CommunityJackpotNavigator from '../navigators/CommunityJackpotNavigator';

export const NAVIGATION_CONFIG: NavigationConfig<AppNavigatorParamsList> = {
  FULL_SCREENS: [],
  FULL_SCREEN_MODALS: [
    {
      name: 'CommunityJackpot',
      options: hideHeader,
      component: CommunityJackpotNavigator,
    },
  ],
  FULL_SCREEN_MODALS_TRANSPARENT: [],
};

const modals = {
  CommunityJackpot: CommunityJackpotNavigator,
};

registerModals('communityJackpot', modals);

registerNavigationHandlers<AppNavigatorParamsList, 'CommunityJackpot'>({
  CommunityJackpot() {
    Modal.open({
      namespace: 'communityJackpot',
      type: 'CommunityJackpot',
      options: {
        hideHeader: true,
      },
      style: {
        width: {
          mobile: '100%',
          tablet: '100%',
          desktop: 550,
        },
        height: {
          mobile: '100%',
          tablet: '100%',
          desktop: 800,
        },
        paddingTop: 'space-200',
        backgroundColor: 'screenBackground',
      },
    });
  },
});

registerNavigationHandlers<
  AppNavigatorParamsList,
  'CommunityJackpotRulesScreen'
>({
  CommunityJackpotRulesScreen(navigate) {
    navigate('/communityjackpotrules');
  },
});

declare global {
  interface RegisteredModals {
    communityJackpot: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}
